module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui grid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ui bottom attached active tab segment",
    attrs: {
      "data-tab": "list-panel"
    }
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.page -= 1
      }
    }
  }, [_vm._v("Before")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.page += 1
      }
    }
  }, [_vm._v("Next")]), _vm._v(" "), _c('div', {
    staticClass: "ui relaxed divided list"
  }, _vm._l((_vm.videos), function(video, index) {
    return _c('video-list-item', {
      attrs: {
        "video": video
      },
      on: {
        "setVideoItem": _vm.setVideoItem
      }
    })
  })), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.page -= 1
      }
    }
  }, [_vm._v("Before")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.page += 1
      }
    }
  }, [_vm._v("Next")])]), _vm._v(" "), _c('div', {
    staticClass: "ui bottom attached tab segment",
    attrs: {
      "data-tab": "player-panel"
    }
  }, [_c('video-item', {
    attrs: {
      "video": _vm.currentVideo
    }
  })], 1), _vm._v(" "), (_vm.currentVideo.video_id) ? _c('div', {
    attrs: {
      "id": "video-player"
    }
  }, [_c('iframe', {
    attrs: {
      "width": _vm.videoPlayerInfo.width,
      "height": _vm.videoPlayerInfo.height,
      "src": '//www.youtube.com/embed/' + _vm.currentVideo.video_id,
      "frameborder": "0",
      "allowfullscreen": "false"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "fb-comments",
    attrs: {
      "data-href": 'https://spinoff.cloudhomez.com/' + _vm.currentVideo.video_id,
      "data-numposts": "5"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui top attached tabular menu"
  }, [_c('a', {
    staticClass: "active item",
    attrs: {
      "data-tab": "list-panel"
    }
  }, [_vm._v("List")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "data-tab": "player-panel"
    }
  }, [_vm._v("Player")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "data-tab": "description-panel"
    }
  }, [_vm._v("Description")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui bottom attached tab segment",
    attrs: {
      "data-tab": "description-panel"
    }
  }, [_c('div', {}, [_vm._v("Video Description")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0570acf9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Video.vue
// module id = 45
// module chunks = 1 2